import React from 'react';
import Stack from '@mui/material/Stack';
import FormHelperText from '@mui/material/FormHelperText';

export const Copyright = () => {
  let versionString = `v${process.env.REACT_APP_VERSION}`;

  return (
    <Stack
      direction={'column'}
      justifyContent='center'
      alignItems='center'
      sx={{mt: 'auto'}}>
      <FormHelperText>{versionString}</FormHelperText>
      <FormHelperText>
        © {new Date().getFullYear()} Hessischer Rundfunk{' '}
      </FormHelperText>
    </Stack>
  );
};
export default Copyright;
